import angular from 'angular';

import gridHeight from '../../../core/shared-service/grid-utils';

class ModalGroupAddSubEntityCtrl {
     /*@ngInject*/
  constructor(PrincipalSvc) {
    this.PrincipalSvc = PrincipalSvc;
  }
    $onInit() {
    	var ctrl = this;
    	
    	// Gestion de la grille
        this.gridOptions = {
            columnDefs: [
                { name: 'getNameWithCode()', displayName: "Nom d'etablisement"}
            ],
            paginationPageSize: 10,
            paginationPageSizes: [10, 50],
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: function(gridApi) {
                ctrl.gridApi = gridApi;
            }
        };
        this.legalEntitySelected =this.resolve.companies[0];
        this.getSubEntityFromLegalEntity();
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    getSubEntityFromLegalEntity(){
        var ctrl = this;
        this.PrincipalSvc.getSubEntities(this.legalEntitySelected.id).then((sub)=>{
            this.resolve.subEntities = sub;
            this.gridOptions.data = this.resolve.subEntities.filter(sub => {
                if (ctrl.resolve.currentSubEntities.find(element => element.code === sub.code)) {
                    return false;
                }
                return sub; 
            });
            this.gridOptions.totalItems = this.gridOptions.data.length;
        });
    }
    
    /**
     * Filtre les sociétés du tableau.
     */
    filterChange() {
        var ctrl = this;
        this.gridOptions.data = this.resolve.subEntities.filter(sub => 
			{
				if (ctrl.resolve.currentSubEntities.find(element => element.id === sub.id) === undefined && (
                        (sub.name && sub.name.toLowerCase().indexOf(this.filterValue.toLowerCase()) !== -1) ||
                        (sub.code && sub.code.toLowerCase().indexOf(this.filterValue.toLowerCase()) !== -1)) ) {
					return true
				}
				return false;
			}
		)
    	this.gridOptions.totalItems = this.gridOptions.data.length;
    }
    
    confirm() {
    	var rows = this.gridApi.selection.getSelectedRows();
    	if (rows) {
    		this.modalInstance.close({rows:rows,legalEntity:this.legalEntitySelected});
    	}
    }
    
    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight() {
        return gridHeight(this.gridApi);
    }
}

angular.module('app.principal').component('modalGroupAddSubEntity', {
    templateUrl: require('./modal-group-add-sub-entity.html'),
    controller: ModalGroupAddSubEntityCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<'
    }
});
